import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ruTranslation from '../locales/ru-ru/translation.json';

i18n
  .use(initReactI18next)
  .init({
    lng: 'ru',
    fallbackLng: 'ru',
    debug: import.meta.env.DEV,
    initImmediate: false,
    resources: {
      ru: {
        translation: ruTranslation,
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;